import React, { useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import './style-card.css'
import ItemTypeCard from './ItemTypeCard';
import DynamicList from './DynamicList';
import { enum__ComponentType } from '../../../../../../../common/Dictionaries';
import CCardTitle from '../../../../../../Templates/CCard/TitleCard';
import ToolBar from '../../../../../../Common/Toolbar';
import { useSelector } from 'react-redux';

function InfoListDynamic(props) {
    const { t } = useTranslation();
    const { _moveZones: boardMoveZones } = useSelector((state) => state.boardScope);
    const { _boardStructureSpecific: boardStructureSpecific } = useSelector((state) => state.boardViewScope);

    const {
        inputParam_BoardId = null,
        inputParam_ComponentInfoList = null,
        inputParam_ComponentContent = null
    } = props;

    const [itemTypeSelected, setItemTypeSelected] = useState(null)
    const [isEditTitleMode, setIsEditTitleMode] = useState(false);
    const itemTypeList = [{
        title: t('data-lang-lbl-books'),
        display: true,
        type: enum__ComponentType.SG3BOOK_LIBROS,
        color: "#000",
        icon: "DocumentSet",
    },{
        title: t('data-lang-lbl-gapactions'),
        display: true,
        type: enum__ComponentType.SG3KPI_GAPACCIONES,
        color: "#000",
        icon: "ScheduleEventAction",
    },{
        title: t('data-lang-lbl-gapevents'),
        display: true,
        type: enum__ComponentType.SG3KPI_GAPEVENTOS,
        color: "#000",
        icon: "Calendar",
    },{
        title: t('data-lang-lbl-bookevents'),
        display: true,
        type: enum__ComponentType.SG3BOOK_EVENTOS,
        color: "#000",
        icon: "CalendarDay",
    }];


    const onChangeEditTitleMode = () => {
        setIsEditTitleMode(true);
    };

    const overflowItems = [
        {
            key: 'editTitle',
            text: t('data-lang-btn-edittitle'),
            iconProps: { iconName: 'Edit' },
            onClick: onChangeEditTitleMode,
        }
    ]

    return (
        <>
            <Card className='h-100 mb-1'>
                <Card.Header className={`${boardMoveZones ?"dragHandle" : ""} card-header-compact`}>
                    <Card.Title className="d-flex justify-content-between">
                        {
                            inputParam_ComponentContent &&
                            <CCardTitle
                                inputParam_CustomTitle={inputParam_ComponentContent.title}
                                inputParam_DefaultTitle={t('data-lang-boxname-relatedelements')}
                                inputParam_ContainerId={inputParam_ComponentContent.id}
                                inputParam_EditMode={isEditTitleMode}
                                inputParam_SetterIsEditTitleMode={setIsEditTitleMode}
                            />
                        }
                        {
                            !inputParam_ComponentContent &&
                            <b>{ t('data-lang-boxname-dataserielist') }</b>
                        }
                        <div className='toolbar d-flex'>
                            <ToolBar overflowItems={ overflowItems } display={true} styles={{root: {padding: 0, height: "30px"}}} />
                        </div>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                    </div>
                </Card.Footer>
                <Card.Body className="h-100">
                {
                    boardStructureSpecific && boardStructureSpecific[0].l_structure[0].l_container.filter(container => container.l_components.some(component => component.componentTypeId === enum__ComponentType.OCR_CHART ||  component.componentTypeId === enum__ComponentType.OCR_CHART_GAUGE)) &&
                    <>
                        <Row>
                            {
                                itemTypeList && itemTypeList.map((item, index) => (
                                    <Col key={index}>
                                        <ItemTypeCard
                                            inputParam_Item={item}
                                            inputParam_SelectedItem={itemTypeSelected}
                                            inputParam_SetterSelectedItem={setItemTypeSelected}
                                            inputParam_Index={index}
                                            inputParam_ArrayLength={itemTypeList.length}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                        {
                            itemTypeSelected && inputParam_ComponentInfoList && inputParam_ComponentInfoList.filter(x =>
                                (x.componentTypeId === enum__ComponentType.SG3BOOK_EVENTOS ||
                                x.componentTypeId === enum__ComponentType.SG3BOOK_LIBROS ||
                                x.componentTypeId === enum__ComponentType.SG3KPI_GAPACCIONES ||
                                x.componentTypeId === enum__ComponentType.SG3KPI_GAPEVENTOS) &&
                                x.componentTypeId === itemTypeSelected.type).map((componentInfo, index) => (
                                <div key={index}>
                                    <DynamicList
                                        inputParam_BoardId={inputParam_BoardId}
                                        inputParam_ComponentInfo={componentInfo}
                                    />
                                </div>                            
                            ))
                        }
                    </>
                }
                </Card.Body>
            </Card>
        </>
    );
}

InfoListDynamic.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_ComponentInfoList: PropTypes.array.isRequired,
    inputParam_ComponentContent: PropTypes.object.isRequired
};

export default InfoListDynamic;

